<template>
  <el-dialog
    title="权限管理"
    :visible.sync="visible"
    width="720px"
    :close-on-click-modal="false"
    @closed="cancelhander"
  >
    <el-transfer
      filterable
      :filter-method="filterMethod"
      filter-placeholder="请输搜索内容"
      v-model="value"
      :data="data"
      class="role-transfer"
    ></el-transfer>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelhander">取 消</el-button>
      <el-button type="primary" @click="handlerTransfer" :loading="btnLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    permsRoleList: Array,
    selePermValue: Array,
    uid: String,
    search: String,
    flag: String,
    permdialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const generateData = () => {
      const data = [];
      const cities = this.permsRoleList;
      // const pinyin = [
      //   "shanghai",
      //   "beijing",
      //   "guangzhou",
      //   "shenzhen",
      //   "nanjing",
      //   "xian",
      //   "chengdu"
      // ];
      cities.forEach((item) => {
        data.push({
          label: item.name,
          key: item.id,
          pinyin: item.name,
        });
      });
      return data;
    };
    return {
      data: generateData(),
      value: this.selePermValue,
      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      },
      visible: false,
      btnLoading: false,
    };
  },
  computed: {},
  watch: {
    permdialogVisible(value) {
      this.visible = value;
    },
    selePermValue: function (val) {
      this.value = val;
    },
    permsRoleList: function (val) {
      const cities = val;
      let arr = [];
      // const pinyin = [
      //   "shanghai",
      //   "beijing",
      //   "guangzhou",
      //   "shenzhen",
      //   "nanjing",
      //   "xian",
      //   "chengdu"
      // ];
      cities.forEach((item) => {
        arr.push({
          label: item.name,
          key: item.id.toString(),
          pinyin: item.name,
        });
      });
      this.data = arr;
    },
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handlerTransfer() {
      let param = {};
      if (this.flag == "user") {
        param = {
          pid: this.value.join(","),
          uid: this.uid,
        };
      } else {
        param = {
          pid: this.value.join(","),
          rid: this.uid,
        };
      }
      this.btnLoading = true;
      this.$store.dispatch(
        this.flag == "user" ? "modifyPermsManage" : "modifyPermsRole",
        {
          param,
          cb: (data) => {
            if (data.code == "0000") {
              this.$notify({
                title: "success",
                message: "修改权限成功",
                type: "success",
              });
              this.visible = false;
              this.$emit("closeDialog");
              this.flag == "user"
                ? this.$store.dispatch("getRoleUserList", {
                    param: {
                      currentPage: this.$store.state.RolePower.userCurrentPage,
                      pageSize: 10,
                      condition: this.search,
                    },
                    cb: () => {
                      this.$emit("closeDialog");
                    },
                  })
                : this.$store.dispatch("getRoleInfoList", {
                    param: {
                      currentPage: this.$store.state.RolePower.roleCurrentPage,
                      pageSize: 10,
                      condition: this.search,
                    },
                    cb: () => {
                      this.$emit("closeDialog");
                    },
                  });
            }
            this.btnLoading = false;
          },
        }
      );
    },
    cancelhander() {
      this.$emit("closeDialog");
      this.visible = false;
    },
  },
};
</script>

<style lang="less">
// .role-transfer .el-transfer-panel {
//   width: 283px;
// }
</style>